import { CommonModule } from "@angular/common";
import { Component, OnDestroy, ElementRef, HostListener, ViewChild } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { MenuItem, MessageService } from "primeng/api";
import { Vcu } from "src/app/model/form/vcu";
import { TranslocoRootModule } from "src/app/transloco-root.module";
import { HttpClientModule } from "@angular/common/http";
import { ToolbarModule } from "primeng/toolbar";
import { AvatarModule } from "primeng/avatar";
import { MenubarModule } from "primeng/menubar";
import { SidebarModule } from "primeng/sidebar";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { ToastModule } from "primeng/toast";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { AuthService } from "../../../service/auth.service";
import { Router, NavigationEnd } from "@angular/router";
import { AccountService } from "src/app/service/account.service";
import { ProjectService } from "src/app/service/project.service";
import { GeolocationService } from "src/app/service/geolocation.service";
import { NotificationService } from "src/app/service/notification.service";
import { SocialService } from "src/app/service/social.service";
import { ImageUrlService } from "src/app/service/image-url.service";
import { RouterModule } from "@angular/router";
import { catchError, filter } from "rxjs/operators";
import { forkJoin, of, Subscription } from "rxjs";
import { enviroment } from "src/environments/environment";
import { PlanInformation } from "src/app/model/response/account-response";
import { GroupedNotification, Notification, NotificationSseEvent, NotificationType } from "src/app/model/notification.model";
import { AiService } from "src/app/service/ai.service";
import { AiUsageResponse, canBuyExtraTokens, freeTankFillPercent, isFreeTankInUse } from "src/app/model/response/ai-response";
import { AccessBlockService, AccessBlockReason } from "src/app/service/access-block.service";
import { AccountSharingAlertService } from "src/app/service/account-sharing-alert.service";
import { ProFeatureModalComponent } from "src/app/share/pro-feature-modal/pro-feature-modal.component";
import { TokenPurchaseModalComponent } from "src/app/share/token-purchase-modal/token-purchase-modal.component";
import { MapPasswordModalComponent } from "src/app/share/map-password/map-password-modal.component";
import { PlanModalService } from "src/app/share/plan-modal.service";
import { AvatarCropperComponent } from "src/app/shared/avatar-cropper/avatar-cropper.component";
import { checkUpload, uploadRejectI18n, UploadCheck } from "src/app/shared/upload/upload-policy";
import { WelcomeTourService } from "src/app/service/welcome-tour.service";

@Component({
  selector: 'app-dashboard-template',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslocoRootModule,
    HttpClientModule,
    ToolbarModule,
    AvatarModule,
    MenubarModule,
    SidebarModule,
    ButtonModule,
    DialogModule,
    ToastModule,
    BreadcrumbModule,
    ProFeatureModalComponent,
    TokenPurchaseModalComponent,
    MapPasswordModalComponent,
    AvatarCropperComponent,
  ],
  providers: [MessageService],
  templateUrl: "./dashboard-template.component.html",
  styleUrl: "./dashboard-template.component.css",
})
export class DashboardTemplateComponent implements OnDestroy {
  items: MenuItem[] | undefined;
  vcus: Vcu[];
  sidebarMenuVisible: boolean;
  sidebarProfileVisible: boolean;
  profileUrl: string;
  adminUrl: string;
  tasksUrl: string;
  eventsUrl: string;
  // feedUrl: string;
  dashboardUrl: string;
  arquivosUrl: string;
  telemetryUrl: string;
  username: string;
  firstName: string;
  lang: string;
  publicProjectsUrl: string;
  favoriteProjectsUrl: string;
  adminUser: boolean = false;
  userId: string;
  footerBackground: string = "url('assets/img/dashboard/Header.svg')";
  notificationCount: number = 0;
  visibleNotifications = false;
  breadcrumbItems: MenuItem[] = [];
  readonly breadcrumbHome: MenuItem = { icon: 'pi pi-home', routerLink: '/my-garage' };
  userEmail: string = '';
  userInitials: string = '';
  socialAvatarUrl: string | null = null;
  planInfo: PlanInformation | null = null;
  showUpgradeModal: boolean = false;
  showBuyTokensModal: boolean = false;
  /** Raw credits_total (não o percentual) — usado pelo TokenPurchaseModalComponent pra calcular o total esperado após a compra. */
  aiCreditsTotal: number | null = null;

  /** Modal de detalhe da notificação "conteúdo removido" (aberto ao clicar na notificação). */
  contentRemovedModalVisible = false;
  contentRemovedInfo: Record<string, any> | null = null;
  /** URL (CDN) da imagem do post removido, resolvida ao abrir o modal. */
  contentRemovedMediaSrc: string | null = null;
  accountType: 'user' | 'tuner' | null = null;
  /** Número mostrado no card do sidebar — ver computeGaugePercent(). */
  aiGaugePercent: number = 0;
  /** % do total já consumido no período. Só alimenta a cor da barra, não o número exibido. */
  private aiOverallUsedPercent: number = 0;
  /**
   * true quando a API retorna tank_size_tokens e o número exibido é o combustível
   * RESTANTE no tanque. false no fallback, onde ainda é o % consumido — o rótulo
   * muda junto, senão diria "disponível" mostrando consumo.
   */
  aiTankMode: boolean = false;
  /**
   * true quando o número exibido é o da reserva gratuita, não o do tanque pago. Troca o
   * rótulo e a cor: sem isso o Free veria "0% disponível", que é verdade sobre o tanque
   * errado — o crédito que ele tem está na reserva.
   */
  aiReserveMode: boolean = false;
  /** Recorte de /AI/usage que decide a compra avulsa; null enquanto não carregou. */
  aiPlanInfo: Pick<AiUsageResponse, 'plan' | 'is_paid'> | null = null;

  get canBuyTokens(): boolean {
    return canBuyExtraTokens(this.aiPlanInfo, this.planInfo?.status);
  }

  /** Abaixo disso o card do sidebar oferece a compra avulsa (% de tanque ainda disponível). */
  private static readonly BUY_TOKENS_THRESHOLD_PERCENT = 15;

  /**
   * Botão "Comprar mais consumo de IA" só aparece quando o tanque pago está acabando:
   * em modo tanque, quando restam <= 15%; em modo reserva, o tanque pago já zerou;
   * no fallback antigo (número é % consumido), quando já se gastou >= 85%.
   */
  get showBuyTokens(): boolean {
    if (!this.canBuyTokens) return false;
    if (this.aiReserveMode) return true;
    const t = DashboardTemplateComponent.BUY_TOKENS_THRESHOLD_PERCENT;
    return this.aiTankMode ? this.aiGaugePercent <= t : this.aiGaugePercent >= 100 - t;
  }
  /** Quando não-nulo, o shell é substituído pela tela de acesso bloqueado (waitlist HML). */
  accessBlocked: AccessBlockReason | null = null;
  /** Modal de aviso de uso simultâneo da conta, detectado no login. Não bloqueia nada. */
  accountSharingAlertVisible: boolean = false;
  /** País do último acesso das outras sessões, já traduzido. Vazio quando a API não informa. */
  accountSharingCountry: string = '';
  /** Full-screen loading enquanto o logout é processado (revoga token + limpa sessão). */
  loggingOut: boolean = false;
  /**
   * Gate da waitlist HML: só libera a shell (menu + router-outlet) após resolver o
   * status de aprovação. Evita o flash do feed interativo antes da tela "precisa de
   * aprovação". Quando aprovação não é exigida no ambiente, já nasce resolvido.
   */
  approvalResolved: boolean = !enviroment.REQUIRE_APPROVAL;

  /** Lista exibida no dropdown (agrupada pelo backend + itens vindos do SSE). */
  aggregatedNotifications: GroupedNotification[] = [];
  notificationPage = 1;
  private readonly notificationPageSize = 20;
  hasMoreNotifications = true;
  loadingNotifications = false;

  @ViewChild('notificacaoPainel') notificacaoPainel!: ElementRef;
  @ViewChild('notificationBtnRef') notificationBtnRef!: ElementRef;

  private sseSubscription: Subscription | null = null;
  private unreadCountSubscription: Subscription | null = null;
  private accountChangedSubscription: Subscription | null = null;
  private planModalSubscription: Subscription | null = null;
  private accessBlockSubscription: Subscription | null = null;
  private breadcrumbLangSubscription: Subscription | null = null;

  /** Header reveal-on-scroll (headroom): esconde ao descer, reaparece ao subir. */
  headerHidden = false;
  private lastScrollY = 0;
  private headerScrollTicking = false;

  @HostListener('window:scroll')
  onWindowScrollHeader(): void {
    // Throttle a 1x por frame; evita recomputar/CD a cada evento de scroll.
    if (this.headerScrollTicking) return;
    this.headerScrollTicking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const delta = y - this.lastScrollY;
      const THRESHOLD = 6; // ignora micro-scrolls (trackpad/inércia)
      if (y <= 60) {
        this.headerHidden = false; // no topo, sempre visível
      } else if (delta > THRESHOLD) {
        this.headerHidden = true; // descendo → esconde
      } else if (delta < -THRESHOLD) {
        this.headerHidden = false; // subindo → reaparece em qualquer posição
      }
      this.lastScrollY = y;
      this.headerScrollTicking = false;
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.visibleNotifications) return;

    const target = event.target as HTMLElement;
    const clickedInsideDropdown = this.notificacaoPainel?.nativeElement?.contains(target);
    const clickedOnButton = this.notificationBtnRef?.nativeElement?.contains(target);

    if (!clickedInsideDropdown && !clickedOnButton) {
      this.visibleNotifications = false;
    }
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private translocoService: TranslocoService,
    private accountService: AccountService,
    private projectService: ProjectService,
    private geolocationService: GeolocationService,
    private notificationService: NotificationService,
    private messageService: MessageService,
    private socialService: SocialService,
    private aiService: AiService,
    private planModalService: PlanModalService,
    private accessBlockService: AccessBlockService,
    private accountSharingAlertService: AccountSharingAlertService,
    private imageUrlService: ImageUrlService,
    private welcomeTourService: WelcomeTourService,
  ) {
    this.profileUrl = "/profile";
    this.dashboardUrl = "/my-garage";
    this.arquivosUrl = "/archives";
    this.publicProjectsUrl = "/public-projects";
    this.favoriteProjectsUrl = "/favorite-projects";
    this.adminUrl = "/management";
    this.tasksUrl = "/tasks";
    this.eventsUrl = "/events";
    // Feed social desativado — o logo e a home do breadcrumb apontam para Minha Garagem.
    // this.feedUrl = "/feed";
    this.telemetryUrl = "/telemetry";
    let name = sessionStorage.getItem("nameUser");
    this.username = name ? name : "User";
    this.firstName = "";
    this.lang = sessionStorage.getItem("language") || "pt-br";
    this.userId = this.authService.getUserInformations();
    // O shell é o dono do heartbeat: toda tela logada passa por ele, e ele é recriado
    // em qualquer login (senha, ativação, OAuth) e em F5/aba nova.
    if (this.userId) this.authService.startHeartbeat();
    this.vcus = [];
    this.sidebarMenuVisible = false;
    this.sidebarProfileVisible = false;

    this.aggregatedNotifications = [];

    this.getLoggedUser();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.buildBreadcrumb(this.router.url);
        // Fecha sidebars automaticamente após qualquer navegação (clique em item de menu).
        this.sidebarMenuVisible = false;
        this.sidebarProfileVisible = false;
        // Shell was created before tokens were available (e.g. during /auth/callback).
        // Re-initialize user data once the OAuth callback has saved tokens and navigated here.
        if (!this.userId) {
          this.reinitAfterOAuth();
        }
      });

    this.planModalSubscription = this.planModalService.open$
      .subscribe(() => { this.showUpgradeModal = true; });
  }

  private buildBreadcrumb(url: string): void {
    const cleanUrl = url.split('?')[0].split('#')[0];
    const segments = cleanUrl.split('/').filter(s => s);

    // Rotas válidas (clicáveis no breadcrumb). Caminhos como `/feed/project` sozinhos
    // não existem — só fazem sentido com o ID, então não viram link.
    const NAVIGABLE_PATHS = new Set<string>([
      '/my-garage',
      // '/feed',
      '/vcu-management',
      '/archives',
      '/events',
      '/management',
      '/ftassistant',
    ]);

    type Item = { label: string; index: number; cumulativePath: string };
    const itemsWithPaths: Item[] = [];
    let cumulativePath = '';

    segments.forEach((segment, idx) => {
      cumulativePath = `${cumulativePath}/${segment}`;
      // ignora IDs (UUID ou numérico)
      if (/^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(segment) || /^\d+$/.test(segment)) return;
      const key = `breadcrumb.${segment}`;
      const translated = this.translocoService.translate(key);
      itemsWithPaths.push({
        label: translated === key ? segment : translated,
        index: idx,
        cumulativePath,
      });
    });

    // Último item = página atual (não clicável). Os demais ganham routerLink se
    // o caminho cumulativo for uma rota navegável conhecida.
    this.breadcrumbItems = itemsWithPaths.map((it, i) => {
      const isLast = i === itemsWithPaths.length - 1;
      if (isLast || !NAVIGABLE_PATHS.has(it.cumulativePath)) {
        return { label: it.label } as MenuItem;
      }
      return { label: it.label, routerLink: it.cumulativePath } as MenuItem;
    });

    // Trilho perfil > projeto: quando o projeto foi aberto a partir de um perfil
    // (navegação com ?fromUser=<id>), insere o crumb clicável do perfil entre
    // "Social Feed" e "Projeto" — permite voltar ao perfil pelo próprio breadcrumb.
    // Feed social desativado — não há mais trilho perfil > projeto do feed.
    // const qIndex = url.indexOf('?');
    // if (qIndex >= 0 && cleanUrl.startsWith('/feed/project/')) {
    //   const fromUser = new URLSearchParams(url.substring(qIndex + 1)).get('fromUser');
    //   if (fromUser) {
    //     const label = this.translocoService.translate('breadcrumb.profile');
    //     const profileCrumb: MenuItem = {
    //       label: label === 'breadcrumb.profile' ? 'Perfil' : label,
    //       routerLink: `/feed/profile/${fromUser}`,
    //     };
    //     // Insere antes do último item (que é a página atual, "Projeto").
    //     this.breadcrumbItems.splice(Math.max(0, this.breadcrumbItems.length - 1), 0, profileCrumb);
    //   }
    // }
  }

  ngOnInit(): void {
    let token = sessionStorage.getItem("token");
    this.translocoService.setActiveLang(this.lang);

    // O breadcrumb traduz os segmentos da URL imperativamente (translate()), que devolve a
    // própria chave enquanto o JSON do idioma ainda não chegou — daí o "Missing translation".
    // selectTranslation() emite quando as traduções do idioma ativo ficam disponíveis e a cada
    // troca de idioma, então o trilho é montado na hora certa e reescrito ao mudar de idioma.
    this.breadcrumbLangSubscription = this.translocoService.selectTranslation()
      .subscribe(() => this.buildBreadcrumb(this.router.url));

    this.accessBlockSubscription = this.accessBlockService.blocked$.subscribe(blocked => {
      this.accessBlocked = blocked;
    });

    this.showAccountSharingAlertIfAny();

    if (token) {
      this.accountService.findUserActive().subscribe({
        next: (data) => {
          this.username = data?.name ? data.name : "User";
          this.firstName = data?.name ? data.name.split(" ")[0] : "User";
          this.accessBlockService.setFromStatus(data?.approvalStatus);
          this.approvalResolved = true;
        },
        error: () => { this.approvalResolved = true; },
      });
    } else {
      this.approvalResolved = true;
    }

    if (this.userId) {
      this.notificationService.connect(this.userId);

      this.unreadCountSubscription = this.notificationService.unreadCount$.subscribe(count => {
        this.notificationCount = count;
      });

      this.sseSubscription = this.notificationService.notifications$.subscribe(event => {
        this.aggregatedNotifications.unshift(this.sseEventToGrouped(event));
        this.messageService.add({
          key: 'notification',
          severity: this.mapSeverity(event.type),
          summary: event.title,
          detail: event.message || '',
          life: 5000,
        });
      });

      this.loadNotifications();
      this.loadSocialAvatar();

      // Re-busca os dados da conta quando o AccountService sinaliza mudança
      // (ex.: tornou-se tuner) — atualiza accountType e o menu do header sem
      // precisar de full refresh.
      this.accountChangedSubscription?.unsubscribe();
      this.accountChangedSubscription = this.accountService.accountChanged$.subscribe(() => {
        this.getLoggedUser();
      });
    }
  }

  private loadSocialAvatar(): void {
    this.socialService.getProfile(this.userId).subscribe({
      next: (p) => { this.socialAvatarUrl = p.avatarUrl ?? null; },
      error: () => {},
    });
  }

  avatarUploading = false;
  avatarCropperVisible = false;
  avatarFileToCrop: File | null = null;
  @ViewChild('avatarFileInput') private avatarFileInput?: ElementRef<HTMLInputElement>;

  /** Toast padrão de upload rejeitado (tipo/tamanho) usando a política central. */
  private notifyUploadRejected(chk: UploadCheck): void {
    const m = uploadRejectI18n(chk);
    this.messageService.add({
      severity: 'error',
      summary: this.translocoService.translate(m.summaryKey),
      detail: this.translocoService.translate(m.detailKey, { '0': m.param }),
    });
  }

  /** Abre o seletor de arquivo para trocar a foto (input escondido, único no template). */
  openAvatarPicker(): void {
    this.avatarFileInput?.nativeElement.click();
  }

  /** Valida a imagem escolhida e abre o diálogo de recorte; o upload real ocorre em onAvatarCropped. */
  onAvatarSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const chk = checkUpload(file, 'avatar');
    if (!chk.ok) {
      input.value = '';
      this.notifyUploadRejected(chk);
      return;
    }

    input.value = ''; // permite re-selecionar o mesmo arquivo depois
    this.avatarFileToCrop = file;
    this.avatarCropperVisible = true;
  }

  /** Sobe a foto já recortada (1:1) vinda do diálogo de ajuste. */
  onAvatarCropped(file: File): void {
    this.avatarUploading = true;
    this.socialService.changeAvatar(this.userId, file).subscribe({
      next: () => {
        // Exibe já o blob local para evitar a race com a propagação do S3; a URL
        // definitiva do servidor é lida na próxima carga do perfil (loadSocialAvatar).
        // Revoga o blob anterior (se houver) para não acumular na troca repetida.
        if (this.socialAvatarUrl?.startsWith('blob:')) {
          URL.revokeObjectURL(this.socialAvatarUrl);
        }
        this.socialAvatarUrl = URL.createObjectURL(file);
        this.avatarUploading = false;
        this.messageService.add({ severity: 'success', summary: 'Avatar', detail: this.translocoService.translate('socialFeed.avatarUpdated') });
      },
      error: () => {
        this.avatarUploading = false;
        this.messageService.add({ severity: 'error', summary: 'Avatar', detail: this.translocoService.translate('socialFeed.avatarError') });
      },
    });
  }

  pageGarage() {
    // Vai pro dashboard e força scroll pro topo (#garage está no topo).
    // Não usamos fragment porque ele dispara scrollIntoView com posições que
    // ficam erradas durante o load assíncrono dos dados.
    this.router.navigate([this.dashboardUrl]).then(() => {
      // requestAnimationFrame garante que rodamos depois do paint atual,
      // evitando o flicker de "rolar pro fim antes do conteúdo aparecer".
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
  }

  pageSharedGarage() {
    this.router.navigate([this.dashboardUrl]).then(() => {
      requestAnimationFrame(() => {
        const target = document.getElementById("projects");
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  }

  pageArquivos() {
    this.router.navigate([this.arquivosUrl]);
  }

  startTour(): void {
    this.sidebarMenuVisible = false;
    this.sidebarProfileVisible = false;
    this.welcomeTourService.startFromAnywhere();
  }

  pageftassistant() {
    this.router.navigate(['/ftassistant']);
  }

  pagePublicProjects() {
    this.router.navigate([this.publicProjectsUrl]);
  }

  pageFavoriteProjects() {
    this.router.navigate([this.favoriteProjectsUrl]);
  }

  myProfile(id: string) {
    this.router.navigate([this.profileUrl + "/" + id]);
  }

  dismissAccountSharingAlert() {
    this.accountSharingAlertVisible = false;
  }

  /** Leva à tela da conta já com a troca de senha aberta — o param é consumido lá. */
  goToChangePassword() {
    this.accountSharingAlertVisible = false;
    this.router.navigate([this.profileUrl + "/" + this.userId], {
      queryParams: { changePassword: 1 },
    });
  }

  /**
   * Aviso de uso simultâneo detectado no login. One-shot: o serviço apaga na leitura,
   * então aparece uma vez por login e não volta a cada entrada no shell.
   */
  private showAccountSharingAlertIfAny() {
    const alert = this.accountSharingAlertService.consume();
    if (!alert) return;
    this.accountSharingCountry = this.countryName(alert.lastSeenCountry);
    this.accountSharingAlertVisible = true;
  }

  /**
   * Nome do país a partir do ISO-2 que a API manda ("AR"). Intl resolve no idioma ativo
   * sem custo de rede; se o browser não souber o código, o próprio código já serve de
   * pista para o usuário.
   */
  private countryName(code: string | null | undefined): string {
    if (!code) return '';
    try {
      return new Intl.DisplayNames([this.lang], { type: 'region' }).of(code) ?? code;
    } catch {
      return code;
    }
  }

  managementAdmin() {
    this.router.navigate([this.adminUrl]);
  }

  adminCheckin() {
    this.router.navigate([this.adminUrl + '/checkin']);
  }

  pageTasks() {
    this.router.navigate([this.tasksUrl]);
  }

  pageEvents() {
    this.router.navigate([this.eventsUrl])
  }

  // Feed social desativado.
  // pageFeed() {
  //   this.router.navigate([this.feedUrl]);
  // }

  pageTelemetry() {
    this.router.navigate([this.telemetryUrl]);
  }

  onPlanUpgraded(): void {
    this.getLoggedUser();
  }


  async logout() {
    this.loggingOut = true;
    this.notificationService.disconnect();
    await this.authService.logout();
  }

  private scrollLockCount = 0;
  private scrollLockY = 0;

  /**
   * Trava/destrava o scroll da página enquanto um p-sidebar está aberto. O
   * `blockScroll` do PrimeNG só põe `overflow:hidden` no body, o que o Safari iOS
   * IGNORA para scroll de toque — por isso o fundo continuava arrastando. A técnica
   * `position:fixed` (preservando o scrollY) trava de verdade em todos os navegadores.
   * Contador porque há dois sidebars que compartilham o lock.
   */
  /**
   * Disparado ao abrir qualquer um dos dois sidebars. Recarrega o uso de IA toda vez
   * (não só na primeira carga do dashboard), pra refletir consumo feito enquanto o
   * usuário estava navegando — a barra anima sozinha do valor antigo pro novo graças
   * ao `transition: width` já existente em `.gprofile-tokens-bar-fill`.
   */
  onSidebarShow(): void {
    this.lockBodyScroll(true);
    this.loadAiUsage();
  }

  lockBodyScroll(lock: boolean): void {
    const body = document.body;
    if (lock) {
      if (++this.scrollLockCount === 1) {
        this.scrollLockY = window.scrollY;
        body.style.position = 'fixed';
        body.style.top = `-${this.scrollLockY}px`;
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
      }
    } else if (this.scrollLockCount > 0 && --this.scrollLockCount === 0) {
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      window.scrollTo(0, this.scrollLockY);
    }
  }

  ngOnDestroy(): void {
    // Se sair com um sidebar aberto, garante que o body não fique travado.
    if (this.scrollLockCount > 0) {
      this.scrollLockCount = 1;
      this.lockBodyScroll(false);
    }
    if (this.socialAvatarUrl?.startsWith('blob:')) {
      URL.revokeObjectURL(this.socialAvatarUrl);
    }
    this.authService.stopHeartbeat();
    this.notificationService.disconnect();
    this.sseSubscription?.unsubscribe();
    this.unreadCountSubscription?.unsubscribe();
    this.accountChangedSubscription?.unsubscribe();
    this.planModalSubscription?.unsubscribe();
    this.accessBlockSubscription?.unsubscribe();
    this.breadcrumbLangSubscription?.unsubscribe();
  }

  pageTunerDashboard(tab?: string) {
    this.router.navigate(['/tuner/dashboard'], tab ? { queryParams: { tab } } : {});
  }

  pageWorkshops() {
    this.router.navigate(['/oficinas']);
  }

  /**
   * Atalho para "Meu Tuner". A seção vive na aba Assinatura do perfil; o fragmento
   * faz a tela rolar até ela em vez de largar o usuário no topo procurando.
   */
  pageMyTuner() {
    this.sidebarProfileVisible = false;
    this.router.navigate(['/profile/subscription'], { fragment: 'meu-tuner' });
  }


  private reinitAfterOAuth(): void {
    this.userId = this.authService.getUserInformations();
    if (!this.userId) return;

    this.authService.startHeartbeat();
    this.getLoggedUser();

    const token = sessionStorage.getItem('token');
    if (token) {
      this.accountService.findUserActive().subscribe({
        next: (data) => {
          this.username = data?.name ?? 'User';
          this.firstName = data?.name?.split(' ')[0] ?? 'User';
          this.accessBlockService.setFromStatus(data?.approvalStatus);
          this.approvalResolved = true;
        },
        error: () => { this.approvalResolved = true; },
      });
    } else {
      this.approvalResolved = true;
    }

    this.notificationService.connect(this.userId);

    this.unreadCountSubscription?.unsubscribe();
    this.unreadCountSubscription = this.notificationService.unreadCount$.subscribe(count => {
      this.notificationCount = count;
    });

    this.sseSubscription?.unsubscribe();
    this.sseSubscription = this.notificationService.notifications$.subscribe(event => {
      this.aggregatedNotifications.unshift(this.sseEventToGrouped(event));
      this.messageService.add({
        key: 'notification',
        severity: this.mapSeverity(event.type),
        summary: event.title,
        detail: event.message || '',
        life: 5000,
      });
    });

    this.loadNotifications();
    this.loadSocialAvatar();
  }

  getLoggedUser() {
  if (!this.userId) return;
  this.accountService.getAccount(this.userId).subscribe((data) => {
    if (data.accessLevel == 2) {
      this.adminUser = true;
      sessionStorage.setItem('_ui_pref_t', 'x2r');
      sessionStorage.setItem('_ui_role', data.adminRole ?? 'super_admin');
    } else {
      sessionStorage.setItem('_ui_pref_t', '');
      sessionStorage.setItem('_ui_role', '');
    }
    this.userEmail = data.email || '';
    this.planInfo = data.planInformation;
    this.accountType = data.accountType ?? null;
    this.userInitials = this.extractInitials(data.name);
    this.loadAiUsage();

    setTimeout(() => {
      this.translocoService
        .selectTranslateObject("dashboard.header")
        .subscribe((value) => {
          const menuItems: MenuItem[] = [
            /*{
              label: value?.feed,
              icon: "pi pi-users",
              command: () => {
                this.pageFeed();
              },
            },*/
            /*{
              label: 'EVENTOS',
              icon: "pi pi-calendar",
              command: () => {
                
                this.pageEvents();
              },
            },*/
            {
              // ids tour-menu-*: alvos do tour de boas-vindas (WelcomeTourService).
              id: "tour-menu-garage",
              label: value?.garage,
              icon: "pi pi-warehouse",
              command: () => {
                this.pageGarage();
              },
            },
            /*{
              label: value?.workshops || 'OFICINAS',
              icon: "pi pi-map-marker",
              command: () => {
                this.pageWorkshops();
              },
            },*/
            {
              id: "tour-menu-archives",
              label: value?.files,
              icon: "pi pi-folder-open",
              command: () => {
                this.pageArquivos();
              },
            },
            /*{
              label: value?.tasks,
              icon: "pi pi-list",
              command: () => {
                this.pageTasks();
              },
            },
            {
              label: value?.caravan,
              icon: "caravan-icon",
              command: () => {
                this.pageTelemetry();
              },
            },*/
          ];

          /*if (this.adminUser == true) {
            menuItems.push({
              label: 'COMPARTILHAMENTO',
              icon: "pi pi-share-alt",
              command: () => {
                this.pageSharedArchives();
              },
            });
            menuItems.splice(3, 0, {
              label: 'TASKS',
              icon: "pi pi-list",
              command: () => {
                this.pageTasks();
              },
            });
          }*/

          menuItems.push({
            id: 'tour-menu-ai',
            label: value?.aiAssistant || 'FT PILOT IA',
            icon: 'ft-icon ft-icon-ftpilot',
            command: () => this.router.navigate(['/ftassistant']),
          });

          if (this.accountType === 'tuner') {
            menuItems.push({
              label: this.translocoService.translate('tuner.panel.menuItem'),
              icon: 'pi pi-star-fill',
              command: () => this.pageTunerDashboard(),
            });
          }

          this.items = menuItems;
        })
        .unsubscribe();
    }, 100);
  });
}


  private loadAiUsage(): void {
    this.aiService.getUsage().subscribe({
      next: (data) => {
        this.aiCreditsTotal = data.credits_total;
        this.aiPlanInfo = { plan: data.plan, is_paid: data.is_paid };
        this.aiReserveMode = isFreeTankInUse(data.free_tank);
        this.aiTankMode = !!data.tank_size_tokens && data.tank_size_tokens > 0;
        this.aiGaugePercent = this.computeGaugePercent(data);
        this.aiOverallUsedPercent = data.credits_total > 0
          ? Math.round((data.credits_used_this_period / data.credits_total) * 100)
          : 0;
      },
      error: () => {
        this.aiGaugePercent = 0;
        this.aiOverallUsedPercent = 0;
        this.aiTankMode = false;
        this.aiReserveMode = false;
        this.aiCreditsTotal = null;
        this.aiPlanInfo = null;
      },
    });
  }

  /**
   * Número exibido no card do sidebar. Com tank_size_tokens presente, mostra o
   * combustível que RESTA no tanque em uso (mesmo conceito da aba Consumo de IA no
   * perfil: parte de cheio e vai baixando); sem o campo, cai no % do total já
   * consumido (comportamento antigo, pra ambientes que ainda não retornam o campo).
   */
  private computeGaugePercent(data: AiUsageResponse): number {
    // A reserva vem primeiro: quando ela é a fonte de gasto, o tanque pago está em zero e
    // medi-lo daria sempre 0% — o combustível que resta é o dela.
    if (isFreeTankInUse(data.free_tank)) {
      return freeTankFillPercent(data.free_tank);
    }
    if (data.tank_size_tokens && data.tank_size_tokens > 0) {
      const total = data.credits_total / data.tank_size_tokens;
      const used = data.credits_used_this_period / data.tank_size_tokens;
      const index = Math.floor(used);
      // Capacidade do tanque em uso — o último pode ser parcial, e aí o "% restante"
      // é relativo à capacidade dele, não a um tanque cheio.
      const capacity = Math.min(1, Math.max(0, total - index));
      if (capacity <= 0) return 0;
      const remaining = Math.max(0, capacity - (used - index));
      return Math.round((remaining / capacity) * 100);
    }
    if (data.credits_total > 0) {
      return Math.round((data.credits_used_this_period / data.credits_total) * 100);
    }
    return 0;
  }

  navigateToAiConsumption(): void {
    this.sidebarMenuVisible = false;
    this.sidebarProfileVisible = false;
    this.router.navigate(['/profile/ai']);
  }

  /**
   * Cor da barra pelo consumo TOTAL do período, não pelo número exibido: com o
   * display invertido (combustível restante), usar o número exibido pintaria de
   * vermelho justamente quando o tanque está cheio.
   */
  getAiBarClass(): string {
    // Na reserva a barra é laranja o tempo todo: aqui o laranja identifica o tipo de
    // crédito (mesmo laranja do galão da reserva na aba de consumo), não o nível. O
    // semáforo mede o período do plano, que na reserva está parado em zero.
    if (this.aiReserveMode) return 'bar-orange';
    if (this.aiOverallUsedPercent >= 85) return 'bar-red';
    if (this.aiOverallUsedPercent >= 60) return 'bar-yellow';
    return 'bar-green';
  }

  openNotifications() {
    this.visibleNotifications = !this.visibleNotifications;
  }

  extractInitials(name: string): string {
    if (!name) return 'U';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  loadNotifications(): void {
    if (this.loadingNotifications) return;
    this.loadingNotifications = true;

    this.notificationService
      .getGroupedNotifications(this.userId, this.notificationPage, this.notificationPageSize)
      .subscribe({
      next: (res) => {
        if (this.notificationPage === 1) {
          this.aggregatedNotifications = [...res.listItens];
        } else {
          this.aggregatedNotifications.push(...res.listItens);
        }
        const tp = res.totalPages;
        if (tp != null && tp > 0) {
          this.hasMoreNotifications = this.notificationPage < tp;
        } else {
          this.hasMoreNotifications = res.listItens.length >= this.notificationPageSize;
        }
        this.loadingNotifications = false;
      },
      error: () => {
        this.notificationService.getNotifications(this.userId, this.notificationPage, 20).subscribe({
          next: (res) => {
            const mapped = res.listItens.map((n) => this.notificationToGrouped(n));
            if (this.notificationPage === 1) {
              this.aggregatedNotifications = mapped;
            } else {
              this.aggregatedNotifications.push(...mapped);
            }
            this.hasMoreNotifications = this.notificationPage < res.totalPages;
            this.loadingNotifications = false;
          },
          error: () => {
            this.loadingNotifications = false;
          },
        });
      },
    });
  }

  loadMoreNotifications(): void {
    this.notificationPage++;
    this.loadNotifications();
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead(this.userId).subscribe(() => {
      this.aggregatedNotifications.forEach((g) => (g.isRead = true));
      this.notificationService.refreshUnreadCount(this.userId);
    });
  }

  onGroupedNotificationClick(g: GroupedNotification): void {
    if (!g.isRead && g.notificationIds?.length) {
      this.notificationService.markBatchAsRead(this.userId, g.notificationIds).subscribe({
        next: () => {
          g.isRead = true;
          this.notificationService.refreshUnreadCount(this.userId);
        },
        error: () => {
          forkJoin(
            g.notificationIds.map((id) =>
              this.notificationService.markAsRead(this.userId, id).pipe(catchError(() => of(null)))
            )
          ).subscribe(() => {
            g.isRead = true;
            this.notificationService.refreshUnreadCount(this.userId);
          });
        },
      });
    }
    // "Conteúdo removido": abre um modal com os detalhes (do payload) em vez de navegar.
    if (g.type === 'ContentRemoved') {
      this.contentRemovedInfo = (g.metadata as Record<string, any>) ?? null;
      this.contentRemovedMediaSrc = this.imageUrlService.transformSocialUrl(
        this.contentRemovedInfo?.['mediaUrl'] ?? null, 'social');
      this.contentRemovedModalVisible = true;
      this.visibleNotifications = false;
      return;
    }
    this.navigateByMetadata(g.metadata ?? undefined);
    this.visibleNotifications = false;
  }

  private navigateByMetadata(meta: Record<string, unknown> | undefined): void {
    if (!meta) return;

    const actionUrl = meta['actionUrl'];
    if (typeof actionUrl === 'string' && actionUrl) {
      this.router.navigateByUrl(actionUrl);
      return;
    }
    const projectId = meta['projectId'];
    if (typeof projectId === 'string' && projectId) {
      this.router.navigate(['/project', projectId]);
      return;
    }
    // Feed social desativado — notificação de post não tem mais destino navegável.
    // const postId = meta['postId'];
    // if (typeof postId === 'string' && postId) {
    //   this.router.navigate(['/feed'], { queryParams: { post: postId } });
    // }
  }

  private sseEventToGrouped(event: NotificationSseEvent): GroupedNotification {
    return {
      groupKey: null,
      notificationIds: [event.id],
      type: event.type,
      title: event.title,
      message: event.message,
      body: null,
      actors: [],
      totalActors: 0,
      isRead: event.isRead,
      createdAt: event.createdAt,
      metadata: event.metadata ? (event.metadata as Record<string, unknown>) : null,
    };
  }

  private notificationToGrouped(n: Notification): GroupedNotification {
    return {
      groupKey: null,
      notificationIds: [n.id],
      type: n.type,
      title: n.title,
      message: n.message,
      body: null,
      actors: [],
      totalActors: 0,
      isRead: n.isRead,
      createdAt: n.createdAt,
      metadata: n.metadata ? (n.metadata as Record<string, unknown>) : null,
    };
  }

  getNotificationIcon(type: string): string {
    const social: Record<string, string> = {
      SocialPostLiked: 'pi pi-heart',
      SocialPostCommented: 'pi pi-comment',
      SocialUserFollowed: 'pi pi-user-plus',
      SocialPostTagged: 'pi pi-at',
      FileUpload: 'pi pi-upload',
    };
    if (social[type]) {
      return social[type];
    }
    const legacy: Record<string, string> = {
      info: 'pi pi-info-circle',
      success: 'pi pi-check-circle',
      warning: 'pi pi-exclamation-triangle',
      error: 'pi pi-times-circle',
    };
    return legacy[type] || 'pi pi-bell';
  }

  getNotificationIconClass(type: string): string {
    const social: Record<string, string> = {
      SocialPostLiked: 'notification-icon-social',
      SocialPostCommented: 'notification-icon-social',
      SocialUserFollowed: 'notification-icon-social',
      SocialPostTagged: 'notification-icon-social',
      FileUpload: 'notification-icon-success',
    };
    if (social[type]) {
      return social[type];
    }
    const classes: Record<string, string> = {
      info: 'notification-icon-info',
      success: 'notification-icon-success',
      warning: 'notification-icon-warning',
      error: 'notification-icon-error',
    };
    return classes[type] || 'notification-icon-info';
  }

  private mapSeverity(type: string): string {
    const map: Record<string, string> = {
      'info': 'info',
      'success': 'success',
      'warning': 'warn',
      'error': 'error',
    };
    return map[type] || 'info';
  }
}

